import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";

export const CampusStudioDetails = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <div>
        {/* Start Page Banner */}
        <div className="page-banner-area bg-1">
          <div className="container">
            <div className="page-banner-content">
              <h1>Campus Studio Details</h1>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li className="navspace">
                  <Link to="/campus">Campus</Link>
                </li>
                <li className="navspace">Studio Details</li>
              </ul>
            </div>
          </div>
        </div>
        {/* End Page Banner */}

        {/* <!--Start Academic Details Area--> */}
        <div className="academics-details-area pt-100 pb-70">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="academics-details">
                  <div className="details">
                    <h2>Innovating Spaces at the Architecture Studio</h2>
                    <p>
                      The architecture lab is where creativity meets
                      functionality. It's a place where visionary designs are
                      brought to life, blending aesthetics with practicality to
                      create transformative spaces.
                    </p>

                    <div className="details-images">
                      <div className="row">
                        <div className="col-lg-4 col-md-4">
                          <img
                            src="assets/images/campus-detail/studio1.webp"
                            height={357} width={700}
                            alt="Image"
                          />
                        </div>
                        <div className="col-lg-4 col-md-4">
                          <img
                            src="assets/images/campus-detail/studio2.webp"
                            height={357} width={700}
                            alt="Image"
                          />
                        </div>
                        <div className="col-lg-4 col-md-4">
                          <img
                            src="assets/images/campus-detail/studio3.webp"
                            height={357} width={700}
                            alt="Image"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="prepare-exam">
                    <h3>Redefining Architecture Through Innovation</h3>
                    <p>
                      At our architecture lab, we push the boundaries of design
                      and functionality. Every project is an opportunity to
                      explore new concepts, technologies, and ideas that
                      redefine how we experience space.
                    </p>
                    <div className="row">
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4>Cutting-Edge Design Techniques</h4>
                          <p>
                            At the lab, we embrace the latest design
                            technologies, from 3D modeling to virtual reality,
                            to visualize and develop innovative architectural
                            solutions.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4>Sustainable Architecture</h4>
                          <p>
                            Sustainability is at the core of our designs. We
                            focus on eco-friendly materials, energy-efficient
                            systems, and sustainable building practices to
                            reduce environmental impact.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4>Collaborative Design Process</h4>
                          <p>
                            Our studio fosters a collaborative environment where
                            architects, engineers, and clients work together to
                            ensure that each project reflects the shared vision
                            of all stakeholders.
                          </p>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="exam-card">
                          <h4>Research and Development in Architecture</h4>
                          <p>
                            We continually push the boundaries of architecture
                            through research, testing new materials, techniques,
                            and methods to advance the field and create
                            groundbreaking designs.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!--End Academic Details Area--> */}
      </div>
    </>
  );
};